/**
 * Define all configs for application here.
 */
export const WP_HOMEPAGE = "https://www.weebpal.com";
export const SLIDER_DEFAULT_OPTIONS = {
  className: "slider variable-width",
  dots: false,
  infinite: true,
  speed: 400,
  slidesToShow: 3,
  slidesToScroll: 3,
  adaptiveHeight: true,
  variableWidth: true,
  centerPadding: '60px',
  responsive: [{
    breakpoint: 992,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: true
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
};

export const BREAK_POINT_RESPONSIVE = {
  desktop: 1200,
  tablet: 992,
  tablet_lg: 768,
  mobile: 640,
  mobile_ms: 480,
}


// WEBPACK FOOTER //
// ./src/const/config.js